import TagsContainer from "@containers/dashboard/tags/_";
import DashboardLayout from "@layouts/dashboard";
import { useQuery } from "@tanstack/react-query";
import Common from "@utilities/common";
import { useEffect } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const Tags = () => {
    const [URLSearchParams] = useSearchParams();

    const { pathname } = useLocation();

    const Navigate = useNavigate();

    const { data, isLoading, refetch } = useQuery(
        [
            "getTags",
            {
                query: URLSearchParams.get("query") || "",
                page: URLSearchParams.get("page") || "1",
            },
        ],
        ({ queryKey }) =>
            Common.api.tags
                .GetAll({
                    query:
                        typeof queryKey[1] !== "string"
                            ? queryKey[1]?.query
                            : "",
                    page:
                        typeof queryKey[1] !== "string"
                            ? queryKey[1]?.page
                            : "1",
                })
                .then((res) => res.data),

        {
            retry: false,
            enabled: true,
            refetchOnWindowFocus: false,
            onSuccess: () => {
                URLSearchParams.set("refetch", "");

                Navigate(
                    {
                        pathname,
                        search: "?" + URLSearchParams.toString(),
                    },
                    {
                        replace: true,
                    },
                );
            },
        },
    );

    useEffect(() => {
        if (URLSearchParams.get("refetch") === "true") {
            refetch();
        }
    }, [URLSearchParams]);

    return (
        <DashboardLayout title="برچسب ها">
            <TagsContainer
                data={data?.result || []}
                loading={isLoading}
                pagination={data?.pagination}
            />
        </DashboardLayout>
    );
};

export default Tags;
